export default __webpack_public_path__ + "static/media/fablab1.dbed624d.jpg";